import { Navigate, useSearchParams } from "react-router-dom";
import { getInvestorQueryParams, withInvestorQuery } from "../../../utils/investorRouteHelpers";

/** Legacy route — investor login now uses the shared /login page. */
export default function InvestorLoginPage() {
  const [searchParams] = useSearchParams();
  const query = getInvestorQueryParams(searchParams);

  return <Navigate to={withInvestorQuery("/login", query)} replace />;
}
